import script from "./DataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataTable.vue?vue&type=script&lang=ts&setup=true"

import "./DataTable.vue?vue&type=style&index=0&id=75231e75&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75231e75"]])

export default __exports__